import { Icon } from "..";
import "./style.scss";

interface CarSpecPropsType {
  icon: string;
  title: string;
  value?: string;
}
const GarageDetailSpecCard = ({ icon, value, title }: CarSpecPropsType) => {
  return (
    <div className="gdc-spec-card">
      <Icon icon={icon} size={18} style={{ marginBlockEnd: 7 }}></Icon>
      <span style={{ marginInline: 4 }}>
        <span className="boldText" style={{ lineHeight: "10px" }}>
          {title}
        </span>
        <p style={{ lineHeight: "10px" }} className="text">
          {value}
        </p>
      </span>
    </div>
  );
};
export default GarageDetailSpecCard;
